import React, { PropsWithChildren, useState } from 'react';
import './Disclaimer.css';
import {
    MappedComponentProperties,
} from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { Section } from '../../importCL';


interface IDisclaimerProps extends MappedComponentProperties {
	shortDescription?: string;
	longDescription?: string;
	backgroundColor?: 'light-grey' | 'white' | undefined;
	alignment?: 'left' | 'center';
	articleStyle?: boolean;
}

export const DisclaimerEditConfig = {
    emptyLabel: 'Disclaimer',
    isEmpty: (props: PropsWithChildren<IDisclaimerProps>) => {
        return !props || !props.shortDescription;
    },
};

const Disclaimer = (
    props: PropsWithChildren<IDisclaimerProps>,
): JSX.Element => {
    const [showLongDesc, setShowLongDesc] = useState(false);
    return (
        <div id='disclaimer' className='Disclaimer'>
            <Section
                className={
                    props.articleStyle
                        ? `Disclaimer__articleSection Disclaimer--${props.alignment}`
                        : `Disclaimer__section Disclaimer--${props.alignment}`
                }
                bgColor={props.backgroundColor}
            >
                {props.articleStyle && <hr className='Disclaimer__articleHr' />}
                <p
                    className={
                        props.articleStyle
                            ? 'Disclaimer__articleShortDescription'
                            : 'Disclaimer__shortDescription'
                    }
                >
                    {props.shortDescription &&
						transformHTMLParserLinks(props.shortDescription)}
                </p>
                {props.longDescription && !showLongDesc && (
                    <a className='link-btn' onClick={() => setShowLongDesc(true)}>
						Read more
                    </a>
                )}
                {props.longDescription && showLongDesc && (
                    <p className='Disclaimer__longDescription'>
                        {transformHTMLParserLinks(props.longDescription)}
                    </p>
                )}
                {props.articleStyle && <hr className='Disclaimer__articleHr' />}
            </Section>
        </div>
    );
};

export default Disclaimer;
